<template>
  <v-row class="mt-0 pt-0">
    <v-col
      v-for="page in pages"
      :key="page.id"
      cols="12"
      md="6"
      lg="4"
      class="d-flex"
    >
      <page-tile
        :page="page"
      >

      </page-tile>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>

<script>
  import { all } from '@/api/page';
  import PageTile from '@/components/pages/PageTile';

  export default {
    name: 'PageTiles',
    data() {
      return {
      };
    },
    asyncComputed: {
      pages: {
        async get() {
          return await all();
        },
        default: [],
      },
    },
    components: {
      PageTile
    },
  };
</script>
